export default "__VITE_ASSET__Dwz5W9l5__"